import { createClient } from '@supabase/supabase-js';
import { createBrowserClient } from '@supabase/ssr';

// Get environment variables
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Create browser client for SSR support
export const createSupabaseBrowserClient = () => {
  return createBrowserClient(
    supabaseUrl,
    supabaseAnonKey
  );
};

/**
 * Resolve a document URL — if it's a relative storage path, convert to full Supabase Storage URL.
 * Prevents 404s when url_archivo is stored as a relative path instead of a full URL.
 */
export const resolveDocUrl = (urlArchivo: string, bucket = 'documentos'): string => {
  if (!urlArchivo) return '';
  if (urlArchivo.startsWith('http://') || urlArchivo.startsWith('https://')) return urlArchivo;
  return `${supabaseUrl}/storage/v1/object/public/${bucket}/${urlArchivo}`;
};

export default supabase;
